/*
 * Copyright (c) Fing. All rights reserved.
 */

import {getCountryName} from "./place/GeoCountries";

export function linkForPlace(countryName, regionName, cityName) {
    if (cityName && regionName && countryName) {
        return '/place/' + countryName + '/' + regionName + '/' + cityName;
    }
    if (regionName && countryName) {
        return '/place/' + countryName + '/' + regionName;
    }
    if (countryName) {
        return '/place/' + countryName;
    }
    return '';
}

export function linkForIsp(isp) {
    if (isp.countryCity && !(isp.countryCity === '')) {
        return '/provider/' + isp.id + '/' + getCountryName(isp.countryCode) +
            (isp.countryRegion ? '/' + isp.countryRegion + '/' : '/all/') + isp.countryCity;
    } else {
        return '/provider/' + isp.id + '/' + getCountryName(isp.countryCode) +
            (isp.countryRegion ? '/' + isp.countryRegion : '');
    }
}